import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { AddeableComponent } from '../../../../shared/components/interfaces/addeable.component';
import { UIDialogService } from '../../../../shared/services/ui-dialog.service';
import { ProductService } from '../../../product/service/product.service';
import { AuthService } from '../../../security/service/auth.service';
import { AssetRoutingStates } from '../../asset-routing.module';
import { AssetService } from '../../service/asset.service';
import { AssetBaseComponent } from '../asset-base.component';
import { AssetSearchStoredInfoModel } from '../model/asset-search-stored-info.model';
import { AssetUIMessages } from '../model/asset-ui.messages';

@Component({
  selector: 'asset-add',
  templateUrl:
    './console/app-js/modules/asset/components/add/asset-add.component.html'
})
export class AssetAddComponent extends AssetBaseComponent
  implements AddeableComponent, OnInit {
  protected duplicateSerialNumber = false;
  protected invalidSerialNumber = false;
  protected invalidAssetTag = false;

  constructor(
    toastr: ToastrService,
    progressService: NgProgress,
    authService: AuthService,
    assetService: AssetService,
    productService: ProductService,
    dialogService: UIDialogService,
    private router: Router
  ) {
    super(
      progressService,
      toastr,
      authService,
      assetService,
      productService,
      dialogService
    );
  }

  /**
   * Set the stored asset customer and site for the current model.
   */
  ngOnInit(): void {
    const assetSearchStoredInfo: AssetSearchStoredInfoModel = this.assetService.getAssetSearchStoredInfo();
    if (assetSearchStoredInfo.site) {
      this.assetModel.site = assetSearchStoredInfo.site;
      this.assetModel.siteId = assetSearchStoredInfo.site.id;
    }
    this.selectedCustomer = assetSearchStoredInfo.customer;
  }

  /**
   * On Save button click, validates the serial number then creates asset if valid, else sends an error message to user.
   */
  onSave(): void {
    this.progressRef.start();
    this.validateUniqueSerialNumberPromise(
      this.assetModel.serialNumber,
      this.assetModel.siteId
    ).then(
      result => {
        this.createAsset();
        this.duplicateSerialNumber = false;
      },
      reason => {
        this.duplicateSerialNumber = true;
        this.onAPIError(reason);
      }
    );
  }

  onCancel(): void {
    this.router.navigate([`/console/${AssetRoutingStates.LIST.url}`]);
  }

  /**
   * Creeates the asset model by calling the endpoint.
   */
  private createAsset(): void {
    if (!this.assetModel.assetLocation) {
      this.assetModel.assetLocation = '';
    } else {
      this.assetModel.assetLocation = this.removeTrailingSpacesForAssetLocation(
        this.assetModel.assetLocation
      );
    }

    this.assetService.createAsset(this.assetModel).subscribe(
      res => {
        if (res.result && res.status === 'Completed') {
          res = res.result;
        }
        if (res.responseCode === 200 && res.results && res.results.id > 0) {
          this.onAPISuccess(AssetUIMessages.ADD_ASSET_SUCCESS);
          this.router.navigate([
            `/console/${AssetRoutingStates.LIST.url}/`,
            res.results.id,
            'view'
          ]);
        } else {
          this.handleError(res.errorMessage ? res.errorMessage : null);
        }
      },
      err => {
        this.handleError(err);
      }
    );
  }

  /**
   * Overrided function to apply special logic when Starbucks site is selected.
   */
  protected onSiteChange() {
    if (this.isStarbucksSiteSelected()) {
      this.assetModel.product = null;
      this.assetModel.productId = null;
    }
    this.invalidSerialNumber = this.validSerialNumber();
    if (this.invalidSerialNumber) {
      this.assetModel.serialNumber = '';
    }
  }
  // validate asset tag input typed in number only.
  protected isInvalidTag(): boolean {
    this.invalidAssetTag = this.validAssetTag();
    return this.invalidAssetTag;
  }
  /**
   * Overrided function to apply special logic when Product selected is changed.
   */
  protected onProductChange(): void {
    this.invalidSerialNumber = this.validSerialNumber();
    if (this.invalidSerialNumber) {
      this.assetModel.serialNumber = '';
    }
  }

  /* Validate Asset Location Characters*/

  validateAssetLocationCharacters(event: any): void {
    const key = String.fromCharCode(event.keyCode);
    if (!this.validAssetLocation(key)) {
      event.preventDefault();
    }
  }

  validateAssetLocationOnPaste(event: ClipboardEvent): void {
    var key = event.clipboardData.getData('text');
    if (this.validateAssetLocationOnCopyPaste(key)) {
      event.preventDefault();
    }
  }
  /**
   * Handles errors
   */
  private handleError(err: string): void {
    console.log(err);
    if (err && err.length > 0) {
      this.onAPIError(err);
    } else {
      this.onAPIError(AssetUIMessages.ADD_ASSET_ERROR);
    }
  }
}
